import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Auth from "../../models/Auth";
// import { useSelector } from "react-redux";

function RequireAuth({ children }) {
    const location = useLocation();
    const portalId = Auth.portalId
    const clientId = Auth.clientId
    if (!portalId && !clientId && location.pathname === "/") {
        if (Auth.token && !Auth.isTokenExpired) {
            return <Navigate to={`/dashboard?pId=${portalId}&cId=${clientId}`} />
        }
        return children
    }
    
    let backURL = (location.pathname !== "/login" || location.pathname !== "/" ) ? encodeURIComponent(location.pathname + location.search) : ''
    backURL = location.search ? "&redirectURL="+backURL : "?redirectURL="+backURL
    if (!portalId || !clientId) return <Navigate to={`/login${location.search}${backURL}`} />;
    return (Auth.token && !Auth.isTokenExpired) ? (
        location.pathname === "/" ? (
            <Navigate to={`/dashboard${location.search}`} replace />
        ) : (
            children
        )
    ) : (
        <Navigate to={`/login${location.search}${backURL}`} replace />
    );
}

export default RequireAuth;
